module.exports = __webpack_public_path__ + "static/img/企业文化4.da692d4f.png";